import useStorage from './useStorage'

export const LOCAL_STORAGE_KEY = 'MY_SAVED_PRODUCTS'

const useSaveToList = () => {
  const { storageValue: value, setStorageValue: setValue } =
    useStorage(LOCAL_STORAGE_KEY)

  const ids: number[] = value ? JSON.parse(value) : []

  const saveToList = (id: number) => {
    const nextIds = [id, ...ids]

    setValue(JSON.stringify(nextIds))
  }

  const removeFromList = (id: number) => {
    const nextIds = ids.filter((num: number) => num !== id)

    setValue(JSON.stringify(nextIds))
  }

  const isPresent = (id: number) => ids.some(num => num === id)

  const toggleIdInList = (id: number) =>
    isPresent(id) ? removeFromList(id) : saveToList(id)

  const setList = (nextIds: number[]) => setValue(JSON.stringify(nextIds))

  return { saveToList, removeFromList, toggleIdInList, isPresent, setList, ids }
}

export default useSaveToList
